<div data-test="form-single-line-input-diff" class="item">
  {{ field.content }}
</div>
